  export const databaseTopics: string[] = [
    "Hosting de Bases de Datos",
    "MySQL en la Nube",
    "PostgreSQL Hosting",
    "SQL Server en la Nube",
    "MongoDB Hosting",
    "Bases de Datos NoSQL",
    "Alta Disponibilidad",
    "Cluster de Bases de Datos",
    "Replicación de Datos",
    "Escalabilidad de Bases de Datos",
    "Optimización de Consultas",
    "Seguridad en Bases de Datos",
    "Backup Automático de Datos",
    "Monitoreo de Bases de Datos",
    "Baja Latencia",
    "Big Data y Analítica",
    "Cifrado de Información",
    "Migración de Bases de Datos",
    "Disaster Recovery para Bases de Datos",
    "Administración de Bases de Datos",
     "MySQL",
     "PostgreSQL",
     "MariaDB",
     "SQL Server",
     "Oracle Database",
     "SQLite",
     "Amazon Aurora",
     "Google Cloud SQL",
     "IBM Db2",
     "MongoDB",
     "Redis",
     "Cassandra",
     "CouchDB",
     "DynamoDB",
     "Firebase Firestore",
     "Neo4j",
     "Amazon DocumentDB",
     "ClickHouse",
     "Apache Hive",
     "Google BigQuery",
     "Snowflake",
     "Apache HBase",
     "Memcached",
     "VoltDB",
     "Hazelcast",
     "TimescaleDB",  
     "InfluxDB",  
     "ArangoDB",  
     "GraphDB",  
     "Etcd",  
     "FoundationDB"
    ];
    
  